import React, { Component } from "react";

/**
 * Template de Email Marketing para código MFA
 * Seguindo boas práticas de email marketing:
 * - HTML inline (sem CSS externo)
 * - Layout com tabelas para compatibilidade
 * - Estilos inline em cada elemento
 * - Sem dependências externas
 * 
 * Acesse via /mfa-demo/email-mkt para visualizar
 */
class MfaEmailTemplate extends Component {
  render() {
    // Dados de exemplo para o template
    const userName = "Fulano de Souza";
    const accessCode = "597648";

    // Logo URL absoluta para email
    const logoUrl = "https://essilorconecta.com.br/static/media/logo-banner-2021.ef55361b.png";

    return (
      <div style={{ backgroundColor: "#e5e5e5", padding: "40px 20px", minHeight: "100vh" }}>
        {/* 
          Template HTML para Email Marketing - Código MFA
          Para usar em produção, copie o conteúdo da tabela abaixo
        */}
        <table
          role="presentation"
          cellPadding="0"
          cellSpacing="0"
          border="0"
          align="center"
          width="100%"
          style={{
            maxWidth: "520px",
            margin: "0 auto",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Header */}
          <tr>
            <td
              style={{
                backgroundColor: "#0394db",
                padding: "20px",
              }}
            >
              <table
                role="presentation"
                cellPadding="0"
                cellSpacing="0"
                border="0"
                width="100%"
              >
                <tr>
                  <td style={{ verticalAlign: "middle", width: "100px" }}>
                    {/* Logo Essilor Conecta */}
                    <img
                      src={logoUrl}
                      alt="Essilor Conecta"
                      width="80"
                      style={{
                        display: "block",
                        border: "0",
                        outline: "none",
                        textDecoration: "none",
                      }}
                    />
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle",
                      paddingLeft: "20px",
                      fontFamily: "Arial, Helvetica, sans-serif",
                      fontSize: "28px",
                      fontWeight: "bold",
                      color: "#ffffff",
                    }}
                  >
                    Código de acesso
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          {/* Conteúdo */}
          <tr>
            <td style={{ padding: "40px 40px 160px 40px", textAlign: "center" }}>
              {/* Saudação */}
              <p
                style={{
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "16px",
                  color: "#424B4A",
                  margin: "0 0 5px 0",
                  lineHeight: "1.5",
                }}
              >
                Prezado, <strong>{userName}</strong>
              </p>

              {/* Subtítulo */}
              <p
                style={{
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "14px",
                  color: "#424B4A",
                  margin: "0 0 20px 0",
                  lineHeight: "1.5",
                }}
              >
                Seu código de acesso é:
              </p>

              {/* Código */}
              <table
                role="presentation"
                cellPadding="0"
                cellSpacing="0"
                border="0"
                width="100%"
              >
                <tr>
                  <td
                    style={{
                      fontFamily: "Arial, Helvetica, sans-serif",
                      fontSize: "48px",
                      fontWeight: "bold",
                      color: "#0394db",
                      letterSpacing: "8px",
                      textAlign: "center",
                      padding: "10px 0 30px 0",
                    }}
                  >
                    {accessCode}
                  </td>
                </tr>
              </table>

              {/* Instrução */}
              <p
                style={{
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "14px",
                  color: "#424B4A",
                  margin: "0 0 40px 0",
                  lineHeight: "1.6",
                  padding: "0 20px",
                }}
              >
                Por favor, retorne à página de login e insira o código acima para
                confirmar a sua identidade.
              </p>

              {/* Aviso de segurança */}
              <p
                style={{
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "14px",
                  color: "#666666",
                  margin: "0",
                  lineHeight: "1.6",
                  padding: "0 10px",
                }}
              >
                Este código é de uso exclusivo e temporário para garantir a
                segurança do seu acesso ao Essilor Conecta. Se você não tentou
                entrar no Conecta por favor entre em contato com o email{" "}
                <a
                  href="mailto:suporte.conecta@essilor.com.br"
                  style={{
                    color: "#0394db",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  suporte.conecta@essilor.com.br
                </a>
              </p>
            </td>
          </tr>

          {/* Footer */}
          <tr>
            <td
              style={{
                backgroundColor: "#0394db",
                padding: "20px",
                textAlign: "center",
              }}
            >
              <img
                src={logoUrl}
                alt="Essilor Conecta"
                width="80"
                style={{
                  display: "inline-block",
                  border: "0",
                  outline: "none",
                  textDecoration: "none",
                }}
              />
            </td>
          </tr>
        </table>

        {/* Versão HTML pura para copiar */}
        <div style={{ 
          maxWidth: "520px", 
          margin: "40px auto 0", 
          padding: "20px",
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
          fontFamily: "monospace",
          fontSize: "12px"
        }}>
          <p style={{ margin: "0 0 10px 0", fontWeight: "bold", color: "#333" }}>
            📋 HTML puro para copiar (clique para selecionar):
          </p>
          <textarea
            readOnly
            style={{
              width: "100%",
              height: "200px",
              fontFamily: "monospace",
              fontSize: "11px",
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              resize: "vertical"
            }}
            value={`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Código de Acesso - Essilor Conecta</title>
</head>
<body style="margin: 0; padding: 0; background-color: #e5e5e5;">
  <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #e5e5e5; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="520" style="max-width: 520px; background-color: #ffffff; border-radius: 8px;">
          <!-- Header -->
          <tr>
            <td style="background-color: #0394db; padding: 20px;">
              <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                <tr>
                  <td style="vertical-align: middle; width: 100px;">
                    <img src="https://essilorconecta.com.br/static/media/logo-banner-2021.ef55361b.png" alt="Essilor Conecta" width="80" style="display: block; border: 0;">
                  </td>
                  <td style="vertical-align: middle; padding-left: 20px; font-family: Arial, Helvetica, sans-serif; font-size: 28px; font-weight: bold; color: #ffffff;">
                    Código de acesso
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <!-- Conteúdo -->
          <tr>
            <td style="padding: 40px 40px 160px 40px; text-align: center;">
              <p style="font-family: Arial, Helvetica, sans-serif; font-size: 16px; color: #424B4A; margin: 0 0 5px 0;">
                Prezado, <strong>${userName}</strong>
              </p>
              <p style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: #424B4A; margin: 0 0 20px 0;">
                Seu código de acesso é:
              </p>
              <p style="font-family: Arial, Helvetica, sans-serif; font-size: 48px; font-weight: bold; color: #0394db; letter-spacing: 8px; margin: 0 0 30px 0;">
                ${accessCode}
              </p>
              <p style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: #424B4A; margin: 0 0 40px 0; line-height: 1.6;">
                Por favor, retorne à página de login e insira o código acima para confirmar a sua identidade.
              </p>
              <p style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: #666666; margin: 0; line-height: 1.6;">
                Este código é de uso exclusivo e temporário para garantir a segurança do seu acesso ao Essilor Conecta. Se você não tentou entrar no Conecta por favor entre em contato com o email <a href="mailto:suporte.conecta@essilor.com.br" style="color: #0394db; text-decoration: none; font-weight: bold;">suporte.conecta@essilor.com.br</a>
              </p>
            </td>
          </tr>
          <!-- Footer -->
          <tr>
            <td style="background-color: #0394db; padding: 20px; text-align: center;">
              <img src="https://essilorconecta.com.br/static/media/logo-banner-2021.ef55361b.png" alt="Essilor Conecta" width="80" style="display: inline-block; border: 0;">
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`}
            onClick={(e) => e.target.select()}
          />
        </div>
      </div>
    );
  }
}

export default MfaEmailTemplate;
